import store from "@/store";
import storageObservable from './storageObservable';
import { Basket } from './basket';

storageObservable.subscribe<Basket>('basket', (basket) => {
    if (store.getters.basketToken === basket.token) store.dispatch('setBasket', basket)
    /*if (store.getters.profileType === 'manager') store.commit('updateManagerClient', {
        cart: basket
    })*/
})

storageObservable.subscribe<any>('basketVersion', (data) => store.dispatch('setBasketVersionFromTab', data))

//вкладку снова открыли или вернулась сеть: корзину могли изменить с другого устройства,
//а изменения этой вкладки могли не дойти до сервера
document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') store.dispatch('basketOnReturn')
})
window.addEventListener('focus', () => store.dispatch('basketOnReturn'))
window.addEventListener('online', () => store.dispatch('syncBasket'))